export const GET_CURRENT_LOCATION_OPTION = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
};
